
import { useState } from "react"
import agent from "../../app/api/agent";
import { Address, AddressDetails } from "../../app/models/order";
import { Autocomplete,  TextField } from "@mui/material";
import { useFormContext } from "react-hook-form";

interface Props {
  setIsRural: (state: boolean) => void
}

export default function AddressSearch({setIsRural} : Props) {
    const methods = useFormContext()
    const [options, setOptions] = useState<Address[]>([])
    
    async function handleChange(event: any) {
        if (event.target.value.length > 5) {
        let originalData = await agent.Orders.getAddresses(event.target.value)
        if (originalData.addresses.length > 0) {
          setOptions(originalData.addresses)
        } 
      } 
    }
    
   async function handleSelect(selectedAddress: string) {
      if (options) {
          let address = options.find((option) => option.full_address === selectedAddress)
          setOptions([])
          if (address) {
            
            let detailsResponse = await agent.Orders.getAddressDetails(address.address_id)
            let addressDetails : AddressDetails = detailsResponse.address

            setIsRural(addressDetails.is_rural_delivery)
            // use the data to get address details from NZPost and then fill the form with the details
           
            methods.reset({...methods.getValues(), 
              address1: addressDetails.street_number + ' ' + addressDetails.street + ' ' + addressDetails.street_type + ', ' + addressDetails.suburb, 
              city: addressDetails.city, 
              postCode: addressDetails.postcode,
              country: addressDetails.country,
              // ruralAddress: addressDetails.is_rural_delivery === true ? 'Yes' : 'No',
              saveAddress: false})
          }
      }
  }
  
  return (
    <>
        
        <Autocomplete
        // freeSolo
        id="address-search"
        data-testid='autocomplete-search'
        disableClearable
        options={options.map((option) => option.full_address)}
        onInputChange={handleChange}
        onChange={(event, value)=> handleSelect(value)}
        noOptionsText='No options'
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search your address"
            InputProps={{
              ...params.InputProps,
              type: 'search',
            }}
          />
        )}
      />
        
     
    </>
  )
}